import api from '@/factories/api';

export default {
  namespaced: true,
  state: {
    versions: [],
    loadedContactId: null,
  },
  getters: {
    versions: (state) => state.versions,
  },
  mutations: {
    setVersions(state, { contactId, versions }) {
      state.versions = versions;
      state.loadedContactId = contactId;
    },
    prependVersion(state, version) {
      state.versions.unshift(version);
    },
    removeVersion(state, version) {
      state.versions = state.versions.filter((v) => v.version !== version);
    },
    clear(state) {
      state.versions = [];
      state.loadedContactId = null;
    },
  },
  actions: {
    async fetchVersions({ commit, state }, contactId) {
      if (state.loadedContactId === contactId) return;
      const versions = await api().get(`contacts/versions/${contactId}`);
      commit('setVersions', { contactId, versions: versions || [] });
    },
    async createVersion({ commit }, { contactId, name }) {
      const newVersion = await api().post(`contacts/versions/${contactId}`, {
        name,
      });
      commit('prependVersion', newVersion);
    },
    async restoreVersion({ commit }, { contactId, version }) {
      await api().put(`contacts/restore/${contactId}`, { version });
      commit('clear');
    },
    async deleteVersion({ commit }, { contactId, version }) {
      await api().delete(`contacts/versions/${contactId}`, {
        data: { version },
      });
      commit('removeVersion', version);
    },
    clearVersions({ commit }) {
      commit('clear');
    },
  },
};
